<div class="container-fluid" [hidden]="AlerterOn">
  <div>
    <!-- <div class="card-header bg-white py-3">
      <h1 class="text-gray-800" style="display: inline-block">
        Import Conductivity Profiles
      </h1>
      
    </div> -->
    <form #form="ngForm" (ngSubmit)="importConductivityprofile()" class="mt-4">
      <!-- Commented on 12th may 2026 for the breadcrumb changes -->
      <!-- <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="name" class="form-label">Plant:</label>
        </div>
        <div class="col-sm-5">
          <select
            class="form-select border border-dark"
            name="plantid"
            (change)="getSelectedId($event)"
          >
            <option [selected]>Select Plant</option>
            <option *ngFor="let plant of plants" [value]="plant.Id">
              {{ plant.Name }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="train" class="form-label">Train:</label>
        </div>
        <div class="col-sm-5">
          <select
            class="form-select border border-dark"
            name="trainid"
            (change)="getSelectedTrainId($event)"
          >
            <option [selected]>Select Train</option>
            <option *ngFor="let train of trains" [value]="train.Id">
              {{ train.Name }}
            </option>
          </select>
        </div>
      </div> -->

      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="importfile">Import File</label>
        </div>
        <div class="col-sm-5">
          <input
            type="file"
            class="form-control border border-dark"
            id="importfile"
            (change)="onFileSelected($event)"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="sync" style="font-weight: bold; color: darkslategrey"
            >Sync</label
          >
        </div>
        <div class="col-sm-1">
          <input
            type="radio"
            id="Alert"
            name="action"
            value="Alert"
            (change)="setSyncOption('Alert')"
            [checked]="this.syncOption == 'Alert'"
          />
          <label for="html">Alert</label>
        </div>
        <div class="col-sm-2">
          <input
            type="radio"
            id="ReplaceExisting"
            name="action"
            value="ReplaceExisting"
            (change)="setSyncOption('ReplaceExisting')"
            [checked]="this.syncOption == 'ReplaceExisting'"
          />
          <label for="css">Replace Existing</label><br />
        </div>
        <div class="col-sm-2">
          <input
            type="radio"
            id="DeleteAllExisting"
            name="action"
            value="DeleteAllExisting"
            (change)="setSyncOption('DeleteAllExisting')"
            [checked]="this.syncOption == 'DeleteAllExisting'"
          />
          <label for="javascript">Delete All Existing</label>
        </div>
      </div>
      

      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="worksheet" class="form-label">Work Sheet</label>
        </div>
        <div class="col-sm-5">
          <input
            type="number"
            class="form-control border border-dark"
            id="worksheet"
            name="worksheet"
            [(ngModel)]="conductivityprofileImport.SelWorksheet"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="colforstage" class="form-label">Column for Stage</label>
        </div>
        <div class="col-sm-5">
          <input
            type="text"
            class="form-control border border-dark"
            id="colForStage"
              name="colForStage"
            [(ngModel)]="conductivityprofileImport.ColForStage"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="headerrow" class="form-label">Header Row</label>
        </div>
        <div class="col-sm-5">
          <input
            type="number"
            class="form-control border border-dark"
            id="colForStage"
            name="colForStage"
            [(ngModel)]="conductivityprofileImport.HeaderRow"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right"></div>
        <div class="col-sm-5">
          <button type="button" (click)="loader()" class="btn custom-buttons-btn">
            Cancel
          </button>
          &nbsp;&nbsp;
          <button type="submit" class="btn custom-buttons-btn">Submit</button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="container-fluid" [hidden]="this.showAlert == false">
  <div class="col-sm-6" style="text-align: left">
    <button class="btn custom-buttons-btn" (click)="refesher()">
      Return to Import Page
    </button>
    &nbsp;&nbsp;
    <button
      class="btn custom-buttons-btn"
      [routerLink]="['/component/conductivityprofile']"
    >
      View Conductivity Profile
    </button>
  </div>

  <div>
    <div class="card-header py-3">
      <h1 class="text-gray-800" style="display: inline-block">
        Import Operation Data Errors
      </h1>
    </div>
    <table
      class="table table-bordered"
      width="100%"
      *ngIf="this.errorsList && this.errorsList.length > 0"
    >
      <tbody>
        <tr *ngFor="let err of this.errorsList">
          <td>{{ err }}</td>
          <td>&nbsp;</td>
          <td>A duplicate entry was detected</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
